import GenderType       from "../../../domain/fundamentals/gender/GenderType";
import FirstName        from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana    from "../../../domain/fundamentals/name/FirstNameKana";
import LastName         from "../../../domain/fundamentals/name/LastName";
import LastNameKana     from "../../../domain/fundamentals/name/LastNameKana";
import Staff            from "../../../domain/staff/Staff";
import StaffMemo        from "../../../domain/staff/StaffMemo";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_STAFF = "SET_STAFF",
  SET_STAFF_LAST_NAME = "SET_STAFF_LAST_NAME",
  SET_STAFF_FIRST_NAME = "SET_STAFF_FIRST_NAME",
  SET_STAFF_LAST_NAME_KANA = "SET_STAFF_LAST_NAME_KANA",
  SET_STAFF_FIRST_NAME_KANA = "SET_STAFF_FIRST_NAME_KANA",
  SET_STAFF_GENDER_TYPE = "SET_STAFF_GENDER_TYPE",
  SET_STAFF_MEMO = "SET_STAFF_MEMO",
}

export interface SetStaff extends ResKaReduxAction {
  staff: Staff;
}

export interface SetStaffLastName extends ResKaReduxAction {
  lastName: LastName;
}

export interface SetStaffFirstName extends ResKaReduxAction {
  firstName: FirstName;
}

export interface SetStaffLastNameKana extends ResKaReduxAction {
  lastNameKana: LastNameKana;
}

export interface SetStaffFirstNameKana extends ResKaReduxAction {
  firstNameKana: FirstNameKana;
}

export interface SetStaffGenderType extends ResKaReduxAction {
  genderType: GenderType;
}

export interface SetStaffMemo extends ResKaReduxAction {
  memo: StaffMemo;
}

export type StaffAction =
  SetStaff
  | SetStaffLastName
  | SetStaffFirstName
  | SetStaffLastNameKana
  | SetStaffFirstNameKana
  | SetStaffGenderType
  | SetStaffMemo
  ;

export const setStaffAction = (staff: Staff): SetStaff => ({
  type: ACTION_TYPE.SET_STAFF,
  staff: staff,
});

export const setStaffLastNameAction = (lastName: LastName): SetStaffLastName => ({
  type: ACTION_TYPE.SET_STAFF_LAST_NAME,
  lastName: lastName,
});

export const setStaffFirstNameAction = (firstName: FirstName): SetStaffFirstName => ({
  type: ACTION_TYPE.SET_STAFF_FIRST_NAME,
  firstName: firstName,
});

export const setStaffLastNameKanaAction = (lastNameKana: LastNameKana): SetStaffLastNameKana => ({
  type: ACTION_TYPE.SET_STAFF_LAST_NAME_KANA,
  lastNameKana: lastNameKana,
});

export const setStaffFirstNameKanaAction = (firstNameKana: FirstNameKana): SetStaffFirstNameKana => ({
  type: ACTION_TYPE.SET_STAFF_FIRST_NAME_KANA,
  firstNameKana: firstNameKana,
});

export const setStaffGenderTypeAction = (genderType: GenderType): SetStaffGenderType => ({
  type: ACTION_TYPE.SET_STAFF_GENDER_TYPE,
  genderType: genderType,
});

export const setStaffMemoAction = (memo: StaffMemo): SetStaffMemo => ({
  type: ACTION_TYPE.SET_STAFF_MEMO,
  memo: memo,
});